// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"G1-z","dimensionLabel":"H1-z","styleChooserControlWrapper":"I1-z","styleChooserControl":"J1-z","disabled":"K1-z","giftCard":"L1-z","styleChooserText":"M1-z"};